import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

function Services() {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <div className="page services-page">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-purple-50 to-indigo-100 py-20 relative overflow-hidden">
        {/* Decorative background elements */}
        <div className="absolute inset-0 bg-gradient-to-r from-purple-100/20 to-blue-100/20"></div>
        <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNlZGYyZjciIGZpbGwtb3BhY2l0eT0iMC4xNSI+PGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMyIvPjwvZz48L2c+PC9zdmc+')] opacity-40"></div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Nossos <span className="text-[#2F5496]">Serviços</span> Transformadores
          </h1>
          <p className="text-2xl text-gray-700 mb-8 max-w-4xl mx-auto leading-relaxed">
            Explore nosso universo de soluções tecnológicas inovadoras. Cada serviço é uma obra-prima de engenharia digital, 
            projetada para revolucionar a forma como você faz negócios e conecta-se com o mundo.
          </p>
          <div className="flex justify-center">
            <Link to="/quote" className="bg-[#2F5496] text-white font-bold text-lg px-8 py-4 rounded-lg hover:bg-[#1e40af] transition-all duration-300 transform hover:scale-105 hover:shadow-xl">
              Começar Agora
            </Link>
          </div>
        </div>
        
        {/* Additional floating elements */}
        <div className="absolute top-16 right-16 w-5 h-5 bg-purple-400 rounded-full opacity-60 animate-ping"></div>
        <div className="absolute bottom-16 left-16 w-7 h-7 bg-indigo-400 rounded-full opacity-50 animate-bounce"></div>
        <div className="absolute top-1/3 right-10 w-4 h-4 bg-purple-300 rounded-full opacity-70 animate-pulse"></div>
      </div>


      {/* Main Services Grid */}
      <div className="container mx-auto px-4 py-20">
        <div className="grid lg:grid-cols-2 gap-12 mb-20">
          {/* Desenvolvimento Web */}
          <div className="card group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-2 border-transparent hover:border-[#2F5496]">
            <div className="p-8">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-blue-200 rounded-xl flex items-center justify-center mr-6 group-hover:rotate-12 transition-transform duration-300">
                  <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                  </svg>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 group-hover:text-[#2F5496] transition-colors duration-300">
                  Desenvolvimento Web
                </h3>
              </div>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Criamos experiências web extraordinárias que cativam e convertem. Nossas aplicações são verdadeiras obras de arte digitais, 
                combinando design impecável com performance excepcional.
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-[#2F5496] rounded-full mr-3"></span>
                  Aplicações React/Next.js de última geração
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-[#2F5496] rounded-full mr-3"></span>
                  Progressive Web Apps (PWA)
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-[#2F5496] rounded-full mr-3"></span>
                  E-commerce de alta performance
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-[#2F5496] rounded-full mr-3"></span>
                  Dashboards interativos e analytics
                </li>
              </ul>
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-lg">
                <p className="text-sm text-gray-600 italic">
                  "Transformamos ideias em realidade digital com precisão cirúrgica e criatividade infinita."
                </p>
              </div>
            </div>
          </div>

          {/* Consultoria em TI */}
          <div className="card group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-2 border-transparent hover:border-green-500">
            <div className="p-8">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-green-100 to-green-200 rounded-xl flex items-center justify-center mr-6 group-hover:rotate-12 transition-transform duration-300">
                  <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 group-hover:text-green-600 transition-colors duration-300">
                  Consultoria Estratégica
                </h3>
              </div>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Navegamos pelo complexo ecossistema tecnológico para traçar o caminho mais eficiente rumo ao sucesso digital. 
                Nossa visão estratégica transforma desafios em oportunidades.
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                  Arquitetura de sistemas escaláveis
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                  Migração para cloud computing
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                  Transformação digital empresarial
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                  Auditoria de segurança e compliance
                </li>
              </ul>
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-lg">
                <p className="text-sm text-gray-600 italic">
                  "Desbloqueamos o potencial oculto da sua infraestrutura com estratégias inovadoras."
                </p>
              </div>
            </div>
          </div>

          {/* Desenvolvimento Mobile */}
          <div className="card group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-2 border-transparent hover:border-purple-500">
            <div className="p-8">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-purple-100 to-purple-200 rounded-xl flex items-center justify-center mr-6 group-hover:rotate-12 transition-transform duration-300">
                  <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 group-hover:text-purple-600 transition-colors duration-300">
                  Desenvolvimento Mobile
                </h3>
              </div>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Aplicativos que transcendem a funcionalidade e se tornam extensões naturais do seu negócio. 
                Criamos experiências móveis que os usuários amam e utilizam diariamente.
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  Apps nativos iOS e Android
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  Cross-platform com React Native
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  Apps híbridos com Flutter
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  Integração com IoT e wearables
                </li>
              </ul>
              <div className="bg-gradient-to-r from-purple-50 to-violet-50 p-4 rounded-lg">
                <p className="text-sm text-gray-600 italic">
                  "Cada toque, cada gesto é pensado para criar uma conexão emocional com seus usuários."
                </p>
              </div>
            </div>
          </div>

          {/* Cloud Solutions */}
          <div className="card group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-2 border-transparent hover:border-orange-500">
            <div className="p-8">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-100 to-orange-200 rounded-xl flex items-center justify-center mr-6 group-hover:rotate-12 transition-transform duration-300">
                  <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
                  </svg>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 group-hover:text-orange-600 transition-colors duration-300">
                  Cloud Solutions
                </h3>
              </div>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Levamos seus dados e aplicações para as nuvens mais avançadas do planeta. 
                Infraestrutura que escala infinitamente e opera com a confiabilidade de um relógio suíço.
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
                  AWS, Azure e Google Cloud
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
                  Kubernetes e containerização
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
                  Serverless architectures
                </li>
                <li className="flex items-center text-gray-700">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
                  Disaster recovery e backup
                </li>
              </ul>
              <div className="bg-gradient-to-r from-orange-50 to-amber-50 p-4 rounded-lg">
                <p className="text-sm text-gray-600 italic">
                  "Sua infraestrutura flutua nas nuvens com a elegância de um balé digital."
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Data Analytics Section */}
        <div className="bg-gradient-to-br from-indigo-50 to-blue-100 rounded-2xl p-12 mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Data Analytics & Business Intelligence
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Transformamos dados brutos em insights valiosos que impulsionam decisões estratégicas. 
              Cada número conta uma história, e nós somos os contadores de histórias.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center group transform hover:scale-105 transition-all duration-300">
              <div className="w-20 h-20 bg-gradient-to-br from-indigo-100 to-indigo-200 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:rotate-12 transition-transform duration-300">
                <svg className="w-10 h-10 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Dashboards Inteligentes</h3>
              <p className="text-gray-600">Visualizações que revelam padrões ocultos e oportunidades de crescimento.</p>
            </div>
            
            <div className="text-center group transform hover:scale-105 transition-all duration-300">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:rotate-12 transition-transform duration-300">
                <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Machine Learning</h3>
              <p className="text-gray-600">Algoritmos que aprendem e evoluem para prever o futuro dos seus negócios.</p>
            </div>
            
            <div className="text-center group transform hover:scale-105 transition-all duration-300">
              <div className="w-20 h-20 bg-gradient-to-br from-purple-100 to-purple-200 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:rotate-12 transition-transform duration-300">
                <svg className="w-10 h-10 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Processamento em Tempo Real</h3>
              <p className="text-gray-600">Análises instantâneas que permitem decisões em tempo real.</p>
            </div>
          </div>
        </div>

        {/* Innovation Technologies */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Tecnologias Emergentes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12">
            Estamos sempre um passo à frente, explorando as fronteiras da inovação tecnológica para trazer soluções que ainda não existem.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-100 to-cyan-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🤖</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Inteligência Artificial</h3>
              <p className="text-gray-600 text-sm">Algoritmos que pensam e aprendem como humanos.</p>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-green-100 to-green-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">⛓️</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Blockchain</h3>
              <p className="text-gray-600 text-sm">Tecnologia que revoluciona a confiança digital.</p>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-100 to-orange-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🌐</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Internet das Coisas</h3>
              <p className="text-gray-600 text-sm">Conectando o mundo físico ao digital.</p>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-100 to-purple-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🥽</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Realidade Virtual</h3>
              <p className="text-gray-600 text-sm">Experiências imersivas que transcendem a realidade.</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-br from-[#2F5496] via-[#1e40af] to-[#1e3a8a] py-20 relative overflow-hidden">
        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-4xl font-bold text-white mb-6">
            Pronto para Revolucionar seu Negócio?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Cada grande inovação começa com uma conversa. Vamos transformar suas ideias em realidade digital extraordinária.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/quote" className="bg-white text-[#2F5496] font-bold text-lg px-8 py-4 rounded-lg hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 hover:shadow-xl">
              Solicitar Orçamento
            </Link>
            <Link to="/contact" className="bg-transparent border-2 border-white text-white font-bold text-lg px-8 py-4 rounded-lg hover:bg-white hover:text-[#2F5496] transition-all duration-300 transform hover:scale-105">
              Falar com Especialista
            </Link>
          </div>
        </div>
        
        {/* Decorative elements */}
        <div className="absolute top-10 left-10 w-20 h-20 bg-white opacity-10 rounded-full animate-ping"></div>
        <div className="absolute bottom-10 right-10 w-16 h-16 bg-white opacity-10 rounded-full animate-pulse"></div>
      </div>
    </div>
  )
}

export default Services